<template>
  <div class="bg-F5F7FA padding-b-100">
    <tool-bar class="bg-FFFFFF" title="Repayment"></tool-bar>
    <div class="padding-h-15">
      <div class="flex-h flex-v-center margin-t-22">
        <div
          class="h-7 w-7 border-p-50"
          style="background: linear-gradient(0deg, #1093ff 0%, #69bbff 100%)"
        ></div>
        <span class="color-888F99 font-16 margin-l-11 font-bold"
          >Payment method selection</span
        >
      </div>

      <div
        @click="switchType(0)"
        class="h-75 radius-15 margin-t-15 flex-h flex-v-center padding-h-15"
        :class="{
          'bg-FFFFFF': type !== 0,
          'linear-gradient-h-1093FF-to-69BBFF': type === 0,
        }"
      >
        <img
          class="w-40 h-40"
          :src="
            type === 0
              ? require('../../assets/select_repay_card.png')
              : require('../../assets/n_select_repay_card.png')
          "
        />
        <span
          class="font-bold font-18 margin-l-15"
          :class="{ 'color-47494A': type !== 0, 'color-FFFFFF': type === 0 }"
          >Repay with Bank Card</span
        >
      </div>

      <div v-show="type === 0" class="font-14">
        <div class="triangle-up margin-l-47 margin-t-10"></div>
        <div class="bg-FFFFFF radius-15 padding-h-24">
          <div v-for="(bank, index) in bankList" :key="index" class="h-88">
            <div
              class="flex-h flex-space-between"
              :class="{ 'opacity-30': bank.status === 3 }"
              @click="
                selectedBankId = bank.status !== 3 ? bank.id : selectedBankId
              "
            >
              <div class="flex-h">
                <img
                  class="w-30 h-30 margin-t-25"
                  src="../../assets/n_select_repay_card.png"
                />
                <div class="flex-v margin-t-20 margin-l-15">
                  <div class="font-18 color-14171B font-bold">
                    {{ bank.name }} ****{{ bank.last4 }}}
                  </div>
                  <div class="font-13 color-888F99 font-bold margin-t-10">
                    Expires {{ bank.expiryMonth }}/{{ bank.expiryYear }}
                  </div>
                </div>
              </div>

              <img
                class="w-20 h-20 margin-r-10 margin-t-25"
                :src="
                  bank.id === selectedBankId
                    ? require('../../assets/select_agreement.png')
                    : require('../../assets/n_select_agreement.png')
                "
              />
            </div>
            <div class="h-line-E6E8EB margin-t-15"></div>
          </div>

          <div
            class="h-67 flex-h flex-v-center flex-space-between"
            @click="jumpBindBankCard()"
          >
            <div class="flex-h flex-v-center">
              <img class="w-30 h-30" src="../../assets/icon_add_bankcard.png" />
              <span class="font-16 color-14171B font-bold margin-l-15"
                >Add bank card</span
              >
            </div>

            <img class="w-10 h-10" src="../../assets/arrow_step.png" />
          </div>
        </div>
      </div>

      <div
        @click="switchType(1)"
        class="h-75 radius-15 margin-t-15 flex-h flex-v-center padding-h-15"
        :class="{
          'bg-FFFFFF': type !== 1,
          'linear-gradient-h-1093FF-to-69BBFF': type === 1,
        }"
      >
        <img
          class="w-40 h-40"
          :src="
            type === 1
              ? require('../../assets/select_repay_ussd.png')
              : require('../../assets/n_select_repay_ussd.png')
          "
        />
        <span
          class="font-bold font-18 margin-l-15"
          :class="{ 'color-47494A': type !== 1, 'color-FFFFFF': type === 1 }"
          >Repay with USSD</span
        >
      </div>

      <div
        @click="switchType(2)"
        class="h-75 radius-15 margin-t-15 flex-h flex-v-center padding-h-15"
        :class="{
          'bg-FFFFFF': type !== 2,
          'linear-gradient-h-1093FF-to-69BBFF': type === 2,
        }"
      >
        <img
          class="w-40 h-40"
          :src="
            type === 2
              ? require('../../assets/select_repay_virtual.png')
              : require('../../assets/n_select_repay_virtual.png')
          "
        />
        <span
          class="font-bold font-18 margin-l-15"
          :class="{ 'color-47494A': type !== 2, 'color-FFFFFF': type === 2 }"
          >Repay with Virtual account</span
        >
      </div>

      <div
        @click="switchType(3)"
        class="h-75 radius-15 margin-t-15 flex-h flex-v-center padding-h-15"
        :class="{
          'bg-FFFFFF': type !== 3,
          'linear-gradient-h-1093FF-to-69BBFF': type === 3,
        }"
      >
        <img
          class="w-40 h-40"
          :src="
            type === 3
              ? require('../../assets/select_repay_qr.png')
              : require('../../assets/n_select_repay_qr.png')
          "
        />
        <span
          class="font-bold font-18 margin-l-15"
          :class="{ 'color-47494A': type !== 3, 'color-FFFFFF': type === 3 }"
          >Repay with QR</span
        >
      </div>
    </div>

    <div
      class="bg-FFFFFF h-71 flex-v flex-h-center"
      style="position: fixed; bottom: 0; width: 100%"
    >
      <div class="padding-h-15">
        <van-button
          style="font-size: 19px; border-radius: 8px; height: 55px"
          color="linear-gradient(to right,#1093FF, #69BBFF)"
          @click="confirmPayType()"
          block
          :loading="btnLoading"
        >
          Confirm
        </van-button>
      </div>
    </div>

    <van-popup class="bg-FFFFFF" v-model="showSelectUSSD" position="bottom">
      <div class="padding-h-20">
        <div class="flex-h flex-v-center flex-space-between h-71">
          <span class="font-19 font-bold color-14171B"
            >Select bank account</span
          >
          <span
            class="font-18 font-bold color-5AB2F9"
            @click="showSelectUSSD = !showSelectUSSD"
            >Cancel</span
          >
        </div>
        <div v-for="(bank, index) in bankUUSDList" :key="index">
          <div class="h-line-E6E8EB"></div>

          <div class="flex-h flex-space-between h-90">
            <div class="flex-h" @click="getUSSDRepayment(bank)">
              <img
                class="w-30 h-30 margin-t-22"
                src="../../assets/icon_bank_default.png"
              />
              <div class="flex-v margin-t-25 margin-l-15">
                <div class="font-18 color-14171B font-bold">
                  {{ bank.bankName }}
                </div>
                <div class="font-15 color-888F99 font-bold margin-t-5">
                  *{{ bank.bankCode }}#
                </div>
              </div>
            </div>

            <img
              class="w-10 h-10 margin-t-30"
              src="../../assets/arrow_step.png"
            />
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showOtp" position="bottom">
      <div class="bg-FFFFFF flex-v flex-v-center padding-b-20">
        <div class="font-21 font-bold color-14171B margin-t-30">OTP</div>
        <div class="font-16 font-bold color-47494A margin-t-19">
          Please enter your OTP
        </div>

        <sms_code_input
          class="margin-t-35"
          v-model="optCode"
          :number="6"
        ></sms_code_input>

        <div class="margin-t-41 color-FFFFFF font-bold">
          <van-button
            style="
              width: 340px;
              height: 55px;
              border-radius: 8px;
              font-size: 19px;
            "
            color="linear-gradient(to right,#1093FF, #69BBFF)"
            :disabled="optCode.length !== 6"
            @click="cardRepayment()"
            block
          >
            Confirm
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showPIN" position="bottom">
      <div class="bg-FFFFFF flex-v padding-b-20">
        <div
          class="font-21 font-bold color-14171B margin-t-30"
          style="text-align: center"
        >
          PIN + CVV
        </div>

        <div class="margin-t-25 padding-h-20">
          <div class="font-16 font-bold color-14171B">
            Please enter your cvv
          </div>

          <div
            class="bg-F7F9FC radius-8 margin-t-15 flex-h flex-v-center"
            style="height: 55px"
          >
            <label class="w-p-100 flex-h flex-v-center padding-h-15">
              <input
                class="w-p-100 input-none-border font-bold color-14171B font-16"
                type="number"
                oninput="value = value.length > 3 ? value.slice(0,3):value"
                v-model="cvv"
              />
            </label>
          </div>
        </div>

        <div class="font-16 font-bold color-47494A margin-t-19 padding-l-20">
          Please enter your PIN code
        </div>

        <sms_code_square_input
          class="margin-t-15"
          v-model="pinCode"
          :number="4"
        ></sms_code_square_input>

        <div class="margin-t-41 color-FFFFFF font-bold flex-h flex-h-center">
          <van-button
            style="
              width: 340px;
              height: 55px;
              border-radius: 8px;
              font-size: 19px;
            "
            color="linear-gradient(to right,#1093FF, #69BBFF)"
            :disabled="cvv.length !== 3 || pinCode.length !== 4"
            @click="cardRepayment()"
            block
          >
            Confirm
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import sms_code_input from "@/components/sms_code_input";
import sms_code_square_input from "@/components/sms_code_square_input";

export default {
  name: "repayment_methods",
  components: { sms_code_square_input, sms_code_input },
  data() {
    return {
      type: 0,
      amount: 0,
      selectedBankId: "",
      showSelectUSSD: false,
      bankList: [],
      bankUUSDList: [],
      showOtp: false,
      showPIN: false,
      optCode: "",
      pinCode: "",
      cvv: "",
      payResult: {},
      btnLoading: false,
    };
  },
  mounted() {
    this.amount = this.$route.query.amount;
    let temAmount = sessionStorage.getItem("amount"); // 第三方跳转返回 金额获取
    if (!this.amount) { //url 没带上取缓存的
      this.amount = temAmount;
    }
    this.getCardMemberList();
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#F5F7FA");
    next();
  },
  beforeRouteLeave(to, from, next) {
    //去除背景色
    document.querySelector("body").setAttribute("style", "");
    next();
  },
  methods: {
    switchType(type) {
      this.type = type;
      if (type === 0) {
        this.getCardMemberList();
      } else if (type === 1) {
        this.getUSSDBankList();
      } else if (type === 2) {
        this.getVirtualAccount();
      } else if (type === 3) {
        this.getQrRepayment();
      }
    },
    jumpUSSDPage(bank, ussdInfo) {
      this.$router.push({
        path: "repayment_ussd",
        query: {
          bank: JSON.stringify(bank),
          ussd: JSON.stringify(ussdInfo),
        },
      });
    },
    confirmPayType() {
      if (this.type === 1) {
        this.showSelectUSSD = true;
      } else if (this.type === 3) {
        this.$router.push({
          path: "repayment_qr",
        });
      } else if (this.type === 0) {
        if (this.selectedBankId !== "") {
          this.cardRepayment();
        } else {
          this.jumpBindBankCard();
        }
      }
    },
    getCardMemberList() {
      this.$showLoading();
      this.$request
        .cardMemberList()
        .then((res) => {
          if (res.length > 0) {
            this.selectedBankId = res[0].id;
          }
          this.bankList = res;
          this.$hideLoading();
        })
        .catch(() => {
          this.$hideLoading();
        });
    },
    getUSSDBankList() {
      this.$showLoading();
      this.$request
        .getUSSDBankList()
        .then((res) => {
          this.$hideLoading();
          this.bankUUSDList = res;
          this.showSelectUSSD = true;
        })
        .catch(() => {
          this.$hideLoading();
        });
    },
    getUSSDRepayment(bank) {
      this.showSelectUSSD = false;
      this.$showLoading();
      let params = {
        type: bank.bankCode,
        amount: this.amount,
      };
      this.$request
        .getUSSDRepayment(params)
        .then((res) => {
          this.$hideLoading();
          this.jumpUSSDPage(bank, res);
        })
        .catch(() => {
          this.$hideLoading();
        });
    },
    getVirtualAccount() {
      this.$showLoading();
      this.$request
        .getVirtualAccount()
        .then((res) => {
          this.$hideLoading();
          if (res && res.bankName !== "" && res.accountNumber !== "") {
            this.$router.push({
              path: "repayment_virtual",
              query: {
                virtual: JSON.stringify(res),
              },
            });
          }
        })
        .catch(() => {
          this.$hideLoading();
        });
    },
    getQrRepayment() {
      let params = {
        provider: "visa",
        amount: this.amount,
      };
      this.$showLoading();
      this.$request
        .getQrRepayment(params)
        .then((res) => {
          this.$hideLoading();
          if (res) {
            this.$router.push({
              path: "repayment_qr",
              query: {
                payInfo: JSON.stringify(res),
              },
            });
          }
        })
        .catch(() => {
          this.$hideLoading();
        });
    },
    cardRepayment() {
      let params = {
        amount: this.amount,
        id: this.selectedBankId,
        cvv: this.cvv,
        pin: this.pinCode,
      };
      this.btnLoading = true; //按钮
      this.$showLoading();
      this.$request
        .cardRepayment(params)
        .then((res) => {
          this.$hideLoading();
          this.btnLoading = false; //按钮

          this.handlePayResult(res);
        })
        .catch(() => {
          this.$hideLoading();
          this.btnLoading = false; //按钮
        });
    },
    handlePayResult(res) {
      this.payResult = res;
      if (res.status === 0) {
        if (res.proxyId === 6) {
          this.showPIN = true;
        }
      } else if (res.status === 1) {
        this.showOtp = true;
      } else if (res.status === 2) {
        // 第三方跳转 保存金额
        sessionStorage.setItem("amount", this.amount);
        this.$router.push({
          path: "third_page",
          query: {
            url: res.url,
          },
        });
      } else {
        this.$router.push({
          path: "pay_result",
          query: {
            type: 2,
            id: res.id,
          },
        });
      }
    },
    jumpBindBankCard() {
      sessionStorage.setItem("amount", this.amount); // 绑卡返回时显示
      this.$router.push({
        path: "bind_bank_card",
      });
    },
  },
};
</script>

<style scoped>
.triangle-up {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}
</style>